import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from '@mui/material';
import ClockLoader from 'shared/components/ClockLoader';
import { useAuth } from 'shared/hooks/useAuth';
import { getLastLoginTenantId } from 'shared/utils/lastTenantLogin';

const SignOutDialog = ({ open, onClose }) => {
  const { signOut, user } = useAuth();
  const [loading, setLoading] = useState(false);
  const tenantId =
    user?.data?.tenantId != null && String(user.data.tenantId).trim() !== ''
      ? String(user.data.tenantId).trim()
      : getLastLoginTenantId() || '';

  const handleLogoutConfirm = async () => {
    setLoading(true);
    try {
      await signOut(tenantId);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80px'
        }}
      >
        <Typography variant="body1">Do you want to logout?</Typography>
      </DialogContent>

      <DialogActions style={{ justifyContent: 'center' }}>
        <Box display="flex" justifyContent="center" mt="20px" gap={2}>
          <Button
            onClick={handleLogoutConfirm}
            color="error"
            variant="contained"
            disabled={loading}
          >
            {loading ? <ClockLoader inline size={24} /> : 'Logout'}
          </Button>

          <Button
            onClick={onClose}
            color="secondary"
            variant="contained"
            disabled={loading}
          >
            Cancel
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default SignOutDialog;
